<template>
  <section id="download">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-card-title align="center">
          <h1 class="font-weight-dark mb-3 mt-3 pw-download-title">
            Screenshots of App
          </h1>
        </v-card-title>
        <div class="image-gallery">
          <v-img src="@/assets/img/app1.png" class="img-1" />

          <v-img src="@/assets/img/app2.png" class="img-2" />

          <v-img src="@/assets/img/app4.png" class="img-3" />

          <v-img src="@/assets/img/app3.png" class="img-4" />

          <v-img src="@/assets/img/app5.png" class="img-5" />
        </div>
      </v-row>
    </v-container>
  </section>
</template>

<style scoped>
#download {
  background: transparent;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 700px;
}

.pw-download-title {
  color: var(--pw-primary-dark);
}

#download .container,
#download .row {
  height: 100%;
}
.image-gallery {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas:
    "img-1 img-2 img-3 img-4"
    "img-1 img-5 img-5 img-6";
}

.image-gallery {
  width: 100%;
  margin-left: 100px;
  margin-right: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.img-1 {
  grid-area: img-1;

  min-height: 20rem;
}
.img-2 {
  grid-area: img-2;

  min-height: 20rem;
}

.img-1:hover,
.img-2:hover,
.img-3:hover,
.img-4:hover,
.img-5:hover,
.img-6:hover {
  transform: scale(1.22);
}
@media screen and (max-width: 600px) {
  #download {
    height: 400px;
  }
  .image-gallery {
    width: 100%;
    margin-left: 10px;
    margin-right: 10px;
  }
  .img-1 {
    grid-area: img-1;

    min-height: 7rem;
  }
  .img-2 {
    grid-area: img-2;

    min-height: 7rem;
  }
}
</style>
